import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [{
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import( /* webpackChunkName: "about" */ '../views/About.vue'),
    },
    {
        path: '/interActor',
        name: 'interActor',
        component: () => import('@/views/interActor/InterActor.vue'),
        meta: {
            title: '展位申请',
        }
    },
    {
        path: '/interVisitor',
        name: 'interVisitor',
        component: () => import('@/views/interActor/InterVisitor.vue'),
        meta: {
            title: '展位申请',
        }
    },
    // 新版直播分享页
    {
        path: '/shareLive',
        name: 'shareLive',
        component: () => import('@/views/liveBroadcastShare/index.vue'),
        meta: {
            title: '展会直播'
        }
    },
    {
        path: '/liveShare',
        name: 'liveShare',
        component: () => import('@/views/liveBroadcastShare/liveShare_old.vue'),
        meta: {
            title: '直播详情'
        }
    },
    {
        path: '/IndustryShare',
        name: 'IndustryShare',
        component: () => import('@/views/IndustryShare/index.vue'),
        meta: {
            title: '行业分享'
        }
    },
    {
        path: '/interview',
        name: 'interview',
        component: () => import('@/views/interview/index.vue'),
        meta: {
            title: '大咖访谈'
        }
    },
    {
        path: '/play',
        name: 'play',//播放页面
        component: () => import('@/views/interview/play.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/player',
        name: 'Player',
        component: () => import('@/views/interview/player.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/map',
        name: 'Map',
        component: () => import('@/views/jinrong/map.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/maps',
        name: 'Maps',
        component: () => import('@/views/jinrong/maps.vue'),
        meta: {
            title: '虚拟展馆'
        }
    },
    {
        path: '/activityList',
        name: 'ActivityList',
        component: () => import('@/views/jinrong/activityList.vue'),
        meta: {
            title: '活动回顾'
        }
    },
    {
        path: '/activitys',
        name: 'Activitys',
        component: () => import('@/views/jinrong/activitys.vue'),
        meta: {
            title: '精彩活动'
        }
    },
    {
        path: '/award',
        name: 'Award',
        component: () => import('@/views/jinrong/award.vue'),
        meta: {
            title: '金融科技发展奖'
        }
    },
    {
        path: '/live',
        name: 'live',//播放页面
        component: () => import('@/views/live/live.vue'),
        meta: {
            title: '视频直播'
        }
    },
    {
        path: '/videoPlay',
        name: 'videoPlay',
        component: () => import('@/views/interview/video-play.vue'),
        meta: {
            title: '视频直播'
        }
    }, {
        path: '/openingRemarks',
        name: 'openingRemarks',
        component: () => import('@/views/openingRemarks/index.vue'),
        meta: {
            title: '开幕寄语'
        }
    },
    {
        path: '/comingSoon',
        name: 'comingSoon',
        component: () => import('@/views/comingSoon/index.vue'),
        meta: {
            title: '敬请期待'
        }
    },
    {
        path: '/enComingSoon',
        name: 'enComingSoon',
        component: () => import('@/views/comingSoon/enComingSoon.vue'),
        meta: {
            title: 'Coming Soon'
        }
    },
    {
        path: '/opening',
        name: 'opening',
        component: () => import('@/views/jinrong/opening.vue'),
        meta: {
            title: '开幕式系列活动'
        }
    },
    {
        path: '/newsDetails',
        name: 'newsDetails',
        component: () => import('@/views/news/newsDetails.vue'),
        meta: {
            title: '新闻详情'
        }
    },
    // ezt3.0新闻详情
    {
        path: '/ezt/news/:id',
        name: 'eztNewsDetails',
        component: () => import('@/views/news/eztDetail.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/openApp',
        name: 'openApp',
        component: () => import('@/views/openApp/openApp.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/down',
        name: 'down1',
        component: () => import('@/views/down/down.vue'),
        meta: {
            title: '下载App'
        }
    },
    {
        path: '/download',
        name: 'download',
        component: () => import('@/views/jinrong/download.vue'),
        meta: {
            title: '金融展'
        }
    },
    {
        path: '/downL',
        name: 'downL',
        component: () => import('@/views/down/downL.vue'),
        meta: {
            title: '下载App'
        }
    },
    {
        path: '/lookback',
        name: 'lookback',
        component: () => import('@/views/jinrong/lookback.vue'),
        meta: {
            title: '历届回顾'
        }
    },
    {
        path: '/jrdetail',
        name: 'jrdetail',
        component: () => import('@/views/jinrong/jrDetail.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/figure/:id',
        name: 'figures',
        component: () => import('@/views/jinrong/figures.vue'),
        meta: {
            title: '2022数字金融嘉年华'
        }
    },
    {
        path: '/newproduct',
        name: 'newproduct',
        component: () => import('@/views/jinrong/newproduct.vue'),
        meta: {
            title: '新品推荐'
        }
    },
    {
        path: '/conference',
        name: 'conference',
        component: () => import('@/views/jinrong/conference.vue'),
        meta: {
            title: '会议活动'
        }
    },
    {
        path: '/conferencelist',
        name: 'conferencelist',
        component: () => import('@/views/jinrong/conferenceList.vue'),
        meta: {
            title: '会议活动'
        }
    },
    {
        path: '/guestList',
        name: 'guestList1',
        component: () => import('@/views/ccbn/guestList.vue'),
        meta: {
            title: '演讲嘉宾'
        }
    },
    {
        path: '/ccbn/hall',
        name: 'hallList',
        component: () => import('@/views/ccbn/hallList.vue'),
        meta: {
            title: '展馆列表'
        }
    },
    {
        path: '/mianliao/plus',
        name: 'MianLiaoPlus',
        component: () => import('@/views/mianliao/plus.vue'),
        meta: {
            title: 'PLUS列表'
        }
    },
    {
        path: '/dict/guestList',
        name: 'guestList',
        component: () => import('@/views/dict/guestList.vue'),
        meta: {
            title: '演讲嘉宾'
        }
    },
    {
        path: '/ml/:type(email|pcydj)',//面料-email预登记邮件-pcizt PC预登记-成功页
        name: 'ml',
        component: () => import('@/views/down/ml.vue'),
        meta: {
            title: '面料'
        }
    },
    {
        path: '/poster/edit',
        name: 'edit',
        component: () => import('@/views/poster/edit.vue'),
        meta: {
            title: '海报制作'
        }
    },
    {
        path: '/poster/show',
        name: 'editShow',
        component: () => import('@/views/poster/show.vue'),
        meta: {
            title: '海报'
        }
    },
    {
        path: '/poster/editText',
        name: 'editText',
        component: () => import('@/views/poster/editText.vue'),
        meta: {
            title: '编辑'
        }
    },
    {
        path: '/poster/list',
        name: 'posterList',
        component: () => import('@/views/poster/list.vue'),
        meta: {
            title: '海报制作'
        }
    },
    {
        path: '/poster/goodslist',
        name: 'goodsList',
        component: () => import('@/views/poster/goodsList.vue'),
        meta: {
            title: '海报制作'
        }
    },
    {
        path: '/poster/myposter',
        name: 'myPoster',
        component: () => import('@/views/poster/myPoster.vue'),
        meta: {
            title: '我的海报'
        }
    },
    {
        path: '/poster/showmodel',
        name: 'showModel',
        component: () => import('@/views/poster/showModel.vue'),
        meta: {
            title: '海报制作'
        }
    },
    {
        path: '/mlPoster/:id',
        name: 'mlPoster',
        component: () => import('@/views/poster/mlPoster.vue'),
        meta: {
            title: '面料海报'
        }
    },
    {
        path: '/videolist',
        name: 'videolist',
        component: () => import('@/views/videoList/videoList.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/mlact',
        name: 'mlact',
        component: () => import('@/views/jinrong/mlact.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/jropen',
        name: 'jropen',
        component: () => import('@/views/jinrong/jrOpen.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/copyUrl',
        name: 'copyUrl',
        component: () => import('@/views/huanbao/copyUrl.vue'),
        meta: {
            title: ''
        }
    },
    // 会议详情
    {
        path: '/meetingDetail',
        name: 'meetingDetail',
        component: () => import('@/views/meeting/meetingDetail.vue'),
        meta: {
            title: '会议详情'
        }
    },
    {
        path: '/attendee',
        name: 'attendee',
        component: () => import('@/views/meeting/attendee.vue'),
        meta: {
            title: '参会人'
        }
    },
    {
        path: '/cardShare/:id',
        name: 'cardShare',
        component: () => import('@/views/mianliao/cardShare/index.vue'),
        meta: {
            title: '领取卡券'
        }
    },
    // 金融pc嘉年华专用
    {
        path: '/online-notice',
        name: 'onlineNotice',
        component: () => import('@/views/jinrong/onlineNotice.vue'),
        meta: {
            title: '2022数字金融嘉年华'
        }
    },
    // TODO临时处理 金融展 海报分享
    {
        path: '/jrdetailnew',
        name: 'jrdetailnew',
        component: () => import('@/views/jinrong/jrDetailnew.vue'),
        meta: {
            title: ''
        }
    },
    // 糖酒会
    {
        path: '/exhibition/intro',
        name: 'ExhibitionIntro',
        component: () => import('@/views/tangjiu/exhibitionIntro.vue'),
        meta: {
            title: '展会介绍'
        }
    },
    {
        path: '/traffic',
        name: 'Traffic',
        component: () => import('@/views/tangjiu/traffic.vue'),
        meta: {
            title: '交通导视'
        }
    },
    {
        path: '/traffic-shiji',
        name: 'TrafficDriving',
        component: () => import('@/views/tangjiu/trafficShiji.vue'),
        meta: {
            title: '世纪城'
        }
    },
    {
        path: '/traffic-xibo',
        name: 'TrafficRoadmap',
        component: () => import('@/views/tangjiu/trafficXibo.vue'),
        meta: {
            title: '西博城'
        }
    },
    {
        path: '/activity-scheduling',
        name: 'ActivityScheduling',
        component: () => import('@/views/tangjiu/activity.vue'),
        meta: {
            title: '活动排期'
        }
    },
    {
        path: '/exhibitor/info',
        name: 'ExhibitorInfo',
        component: () => import('@/views/tangjiu/exhibitorInfo.vue'),
        meta: {
            title: '全国糖酒商品交易会'
        }
    },
    {
        path: '/cac/site',
        name: 'CacSite',
        component: () => import('@/views/cac/site.vue'),
        meta: {
            title: '中国国际农用化学品及植保展览会'
        }
    },
    {
        path: '/cac/hall',
        name: 'CacHall',
        component: () => import('@/views/cac/hall.vue'),
        meta: {
            title: '中国国际农用化学品及植保展览会'
        }
    },
    {
        path: '/cac/fieldServer',
        name: 'CacFieldServer',
        component: () => import('@/views/cac/fieldServer.vue'),
        meta: {
            title: '中国国际农用化学品及植保展览会'
        }
    },
    {
        path: '/glasses/exhibitorChoice',
        name: 'ExhibitorChoice',
        component: () => import('@/views/glasses/exhibitorChoice.vue'),
        meta: {
            title: '展商精选'
        }
    },
    {
        path: '/invite/employee',
        name: 'inviteEmployee',
        component: () => import('@/views/invite/employeeList.vue'),
        meta: {
            title: '员工列表'
        }
    },
    {
        path: '/invite/send',
        name: 'inviteSend',
        component: () => import('@/views/invite/send.vue'),
        meta: {
            title: '发送邀约'
        }
    },
    {
        path: '/invite/list',
        name: 'inviteList',
        component: () => import('@/views/invite/list.vue'),
        meta: {
            title: '我的邀约'
        }
    },
    {
        path: '/invite/staff',
        name: 'inviteStaff',
        component: () => import('@/views/invite/staff.vue'),
        meta: {
            title: '我的邀约'
        }
    },
    {
        path: '/ai',
        name: 'Ai',
        component: () => import('@/views/ai/index.vue'),
        meta: {
            title: 'AI智能服务'
        }
    },
    {
        path: '/ai/chats',
        name: 'ChatsAI',
        component: () => import('@/views/ai/chat.vue'),
        meta: {
            title: 'AI智能服务'
        }
    },
    {
        path: '/tang/hotel',
        name: 'Hotel',
        component: () => import('@/views/tangjiu/hotel.vue'),
        meta: {
            title: ''
        }
    },
];

const router = new VueRouter({
    routes,
});

router.beforeEach((to, from, next) => { //beforeEach是router的钩子函数，在进入路由前执行
    if (to.meta.title) { //判断是否有标题
        console.log(to.meta.title)
        document.title = to.meta.title
    }
    next();
})

export default router;